<template>
	<v-card>
		<v-card-title style="display: block;">
			<div class="d-flex">
				<span class="headline">انتخاب مشتری</span>
				<v-spacer />
				<v-btn @click="$emit('close')" icon>
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</div>
		</v-card-title>
		<v-card-text>
			<v-container>
				<div>
					<div>
						<v-text-field @change="loadData" v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
					</div>
					<div class="">
						<v-checkbox class="small" color="secondary" @change="checkboxAllChanged" label="انتخاب همه" />
					</div>
					<v-data-table fixed-header dense :options.sync="options" :server-items-length="countAll" :headers="headers" :loading="loading" :items="members" :footer-props="{ 'items-per-page-options': [5, 25, 50, 100] }" :items-per-page="itemsPerPage" :search="search" class="elevation-1">
						<template v-slot:item.ch="{ item }">
							<v-checkbox color="secondary" v-model="item.ch" @change="(val) => checkboxChanged(val, item)" />
						</template>
					</v-data-table>
				</div>
			</v-container>
		</v-card-text>
		<v-divider></v-divider>
		<v-card-actions>
			<v-spacer />
			<v-btn color="blue" dark @click="emitSelectedItems">
				تایید آیتم های انتخاب شده
			</v-btn>
			<v-spacer />
		</v-card-actions>
		<confirm-dlg ref="confirm" />
	</v-card>

</template>

<script>
	import api from '@/util/app-api'
	import { emptyId } from '@/util/emptyId'
	import toast from '@/util/toast'

	export default {
		name: 'MembersSelector',
		props: {
			selectedIds: { type: Array }
		},
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {
				emptyId: emptyId,
				search: '',
				selectedItems: [],
				errorMessages: '',
				members: [],
				countAll: 0,
				options: {},
				headers: [
					{
						text: '',
						align: 'start',
						sortable: true,
						value: 'ch',
						width: 20
					}, {
						text: 'نام',
						align: 'start',
						sortable: true,
						value: 'firstName',
					}, {
						text: 'نام خانوادگی',
						align: 'start',
						sortable: true,
						value: 'lastName',
					}, {
						text: 'کد ملی',
						align: 'center',
						sortable: true,
						value: 'nationalCode',
					}, {
						text: 'موبایل',
						align: 'center',
						sortable: true,
						value: 'mobile',
					}, {
						text: 'تاریخ عضویت',
						align: 'center',
						sortable: true,
						value: 'regDate2_Persian.date',
					}
				],
				loading: false,
				previousSearch: null,
				itemsPerPage: 50
			}
		},
		computed: {
		},
		watch: {
			options: {
				handler() {
					this.loadData()
				},
				deep: true,
			}
		},
		mounted() {
			this.loadData()
		},
		methods: {
			loadData(e) {
				if (this.loading) {
					return
				}
				if (e && e === this.previousSearch)
					return
				this.previousSearch = this.search
				this.loading = true
				const data = {
					sortBy: this.options.sortBy,
					sortDesc: this.options.sortDesc,
					page: (this.options.page || 1),
					itemsPerPage: (this.options.itemsPerPage || this.itemsPerPage),
					search: this.search
				}

				api.post('admin/member/DynamicListLight/', data)
					.then(response => {
						this.members = response.members.map(x => {
							x.ch = this.selectedIds.includes(x.id)
							return x
						})
						this.countAll = response.countAll
					})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			checkboxChanged(state, item) {
				let index = this.selectedItems.findIndex(x => x.id === item.id)
				if (!state && index > -1)
					this.selectedItems.splice(index, 1)
				if (state && index === -1) {
					this.selectedItems.push(item)
				}
			},
			emitSelectedItems() {
				if (!this.selectedItems.length) {
					toast.error('حداقل یک آیتم باید انتخاب شود.')
					return
				}
				this.$emit('select', this.selectedItems.map(x => x.id))
				this.$emit('close')
			},
			checkboxAllChanged(state) {
				this.members.forEach(x => { x.ch = state })
				if (!state) {
					this.selectedItems = []
				} else {
					this.selectedItems = [...this.members]
				}
			}
		},
	}
</script>
<style></style>
